export default function removeAllSpaces(text: string) {
    return text.replace(/\s/g, '')
}
